import { BASE_URL, VERSIONE } from "config";
import { Endpoint, ResponseStatus, Session } from "types";

export const getSession = async (guid: string) => {
  const endpointResponse = await fetch(`${BASE_URL}/ep.aspx?v=${VERSIONE}`);
  const endpoint = (await endpointResponse.json()) as Endpoint;
  const response = await fetch(
    `${BASE_URL}/${endpoint.Endpoint}/Boxes.svc/REST/GetS3Key/web/${guid}`,
    { method: "POST" }
  );
  const { status, statusText, ok } = response;
  const resposeStatus: ResponseStatus = { status, statusText, ok };
  const data = (await response.json()) as Session;
  return { response: data, resposeStatus };
};
